import { TreeId } from "@evergis/ui";
import { ImportObject } from "../types";

export const concatObjects = (items: ImportObject[], selected: TreeId[]): ImportObject[] => {
  let result: ImportObject[] = [];

  items?.forEach(item => {
    if (item.children?.length) {
      result = [...result, ...concatObjects(item.children, selected)];
    } else if (!item.disabled && selected?.includes(item.id)) {
      result = [...result, item];
    }
  });

  return result;
};
